// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"edc1fc30","453":"490d5851"}[chunkId] + ".chunk.js";
};